import { atom, atomFamily, selector, selectorFamily } from 'recoil'
import { BROADCAST_TABLE_KEYS } from './keys'
import { formatYYYYMMDD } from 'core/util/date'
import API from 'core/api'

/**
 * 오늘의 Date 정보
 */
export const currentDate = new Date()

/**
 * 라이브 편성표에서 지난 방송 배열의 인덱스
 */
export const PREV_BROADCAST_LIST_INDEX = atom<number>({
  key: BROADCAST_TABLE_KEYS.PREV_BROADCAST_LIST_INDEX,
  default: 0,
})

/**
 * 라이브 편성표에서 현재 시간 이후 방송 배열의 인덱스
 *
 * 라이브 편성표 "더보기" 기능에 사용
 */
export const MORE_BROADCAST_LIST_INDEX = atom<number>({
  key: BROADCAST_TABLE_KEYS.MORE_BROADCAST_LIST_INDEX,
  default: 0,
})

/**
 * 라이브 편성표에서 지난 방송이 존재하는지 여부
 */
export const IS_PREV_BROADCAST_DATA_EXIST = atom<boolean>({
  key: BROADCAST_TABLE_KEYS.IS_PREV_BROADCAST_DATA_EXIST,
  default: false,
})

/**
 * 라이브 편성표에서 선택한 일자
 */
export const SELECTED_BROADCAST_DATE = atom<Date>({
  key: BROADCAST_TABLE_KEYS.SELECTED_BROADCAST_DATE,
  default: currentDate,
})

/**
 * 라이브 편성표에서 선택한 일자의 방송 목록
 */
export const BROADCAST_LIST = atomFamily<BroadcastListResponse['items'], Date>({
  key: BROADCAST_TABLE_KEYS.BROADCAST_LIST,
  default: () => {
    return { past: [], fromNow: [] }
  },
})

/**
 * 라이브 편성표에서 각 일자의 방송 개수
 */
export const GET_BROADCAST_COUNT = selector<Record<string, number> | undefined>({
  key: BROADCAST_TABLE_KEYS.BROADCAST_COUNT,
  get: async () => {
    const prevDateList = Array.from({ length: 2 }, (_, index) => {
      const prevDate = new Date(currentDate)
      prevDate.setDate(currentDate.getDate() - (index + 1))
      return formatYYYYMMDD({ date: prevDate })
    }).reverse()

    const formattedCurrentDate = formatYYYYMMDD({ date: currentDate })

    const nextDateList = Array.from({ length: 7 }, (_, index) => {
      const nextDate = new Date(currentDate)
      nextDate.setDate(currentDate.getDate() + (index + 1))
      return formatYYYYMMDD({ date: nextDate })
    })

    const dateList = [...prevDateList, formattedCurrentDate, ...nextDateList]

    try {
      const broadcastCount = await API.getBroadcastCount(dateList)
      return broadcastCount
    } catch (e) {
      console.log(e)
    }
  },
})

/**
 * 라이브 편성표에서 이전, 다음 일자의 방송 목록 fetch selector
 */
export const GET_PREV_NEXT_BROADCAST_LIST = selectorFamily<BroadcastListResponse | undefined, Date>(
  {
    key: BROADCAST_TABLE_KEYS.GET_PREV_NEXT_BROADCAST_LIST,
    get: (date) => async () => {
      try {
        const broadcastList = await API.getPrevNextBroadcastList(date)
        return broadcastList
      } catch (e) {
        console.log(e)
      }
    },
  },
)

/**
 * 라이브 편성표에서 오늘 일자의 방송 목록 fetch selector
 */
export const GET_TODAY_BROADCAST_LIST = selector<BroadcastListResponse | undefined>({
  key: BROADCAST_TABLE_KEYS.GET_TODAY_BROADCAST_LIST,
  get: async () => {
    try {
      const broadcastList = await API.getTodayBroadcastList()
      return broadcastList
    } catch (e) {
      console.log(e)
    }
  },
})
